import moment from 'moment';
import React from 'react';
import {
    downloadRecap,
    generatePricingData,
    generateTimeBlocks,
    getWeeksNumbersFromCampaign,
    numberWithSpaces
} from '../../utils/pricing';

export const Pricing = (props: {
    screenNumber: number;
    shopsNumber: number;
    slots: number;
    planning: number[][];
    hideFromInterface: boolean;
    startDate: Date;
    endDate: Date;
}) => {
    const totalVariables = {
        totalLogs: 0,
        totalAudience: 0,
        totalContacts: 0,
        totalBrut: 0,
        totalAdserving: 0,
        total: 0
    };

    const logsArray: number[] = [];
    const contactsArray: number[] = [];
    const brutArray: number[] = [];
    const adServingArray: number[] = [];

    const weeks = getWeeksNumbersFromCampaign(props.startDate, props.endDate);

    return (
        <div className="pricing">
            <div className="row">
                <table className="table table-responsive table-price">
                    <thead>
                        <tr>
                            <th>No de semaine</th>
                            <th>Durée (nb de jours)</th>
                            <th>Date début</th>
                            <th>Date fin</th>
                            <th>Répétition par min</th>
                            <th>Tranche horaires</th>
                            <th>Nb d'heures par jour</th>
                            <th>Nb d'heures / semaine</th>
                            <th>Nb magasins</th>
                            <th>Nb d'écrans</th>
                            <th>Logs</th>
                            <th>Audience</th>
                            <th>Nb Contacts estimés</th>
                            <th>Prix Media Brut</th>
                            <th>Adserving</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {weeks.map((w) => {
                            const data = generatePricingData(
                                w,
                                props.startDate,
                                props.endDate,
                                props.planning,
                                props.hideFromInterface,
                                props.screenNumber,
                                props.slots,
                                totalVariables,
                                logsArray,
                                contactsArray,
                                brutArray,
                                adServingArray
                            );

                            return (
                                <tr key={w}>
                                    <td>{w}</td>
                                    <td>{moment(data.cursorEnd).diff(data.cursor, 'days')}</td>
                                    <td>{moment(data.cursor).format('DD/MM/yyyy')}</td>
                                    <td>{moment(data.cursorEnd).format('DD/MM/yyyy')}</td>
                                    <td>{props.slots}</td>
                                    <td>
                                        {!props.planning[0].length ||
                                            generateTimeBlocks(props.planning).reduce((acc, t) => acc + ' + ' + t)}
                                    </td>
                                    <td>{data.hoursNb}</td>
                                    <td>
                                        {props.planning.reduce(
                                            (acc, d) => acc + d.length + (d.indexOf(22) !== -1 ? -1 : 0),
                                            0
                                        )}
                                    </td>
                                    <td>{props.shopsNumber}</td>
                                    <td>{props.screenNumber}</td>
                                    <td>{numberWithSpaces(data.logs)}</td>
                                    <td>{numberWithSpaces(data.audience)}</td>
                                    <td>{numberWithSpaces(data.contacts)}</td>
                                    <td>{numberWithSpaces(data.prix_brut)} &euro;</td>
                                    <td>{numberWithSpaces(data.frais_tech)} &euro;</td>
                                    <td>{numberWithSpaces(data.sumPrices)} &euro; (*)</td>
                                </tr>
                            );
                        })}
                        <tr className="total">
                            <td>Total</td>
                            <td>{moment(props.endDate).diff(props.startDate, 'days') + 1}</td>
                            <td>{moment(props.startDate).format('DD/MM/yyyy')}</td>
                            <td>{moment(props.endDate).add(1, 'd').format('DD/MM/yyyy')}</td>
                            <td>{props.slots}</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>{props.shopsNumber}</td>
                            <td>{props.screenNumber}</td>
                            <td>{numberWithSpaces(totalVariables.totalLogs)}</td>
                            <td>{numberWithSpaces(totalVariables.totalAudience)}</td>
                            <td>{numberWithSpaces(totalVariables.totalContacts)}</td>
                            <td>{numberWithSpaces(totalVariables.totalBrut)} &euro;</td>
                            <td>{numberWithSpaces(totalVariables.totalAdserving)} &euro;</td>
                            <td>{numberWithSpaces(totalVariables.total)} &euro; (*)</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="row">
                <span className="price">* Prix indicatif moyen observ&eacute; sur une semaine. Nous consulter.</span>
            </div>
            <div className="row">
                <button
                    className="btn btn-default mt-10"
                    onClick={() =>
                        downloadRecap(
                            'Planning project',
                            weeks,
                            props.startDate,
                            props.endDate,
                            props.planning,
                            props.hideFromInterface,
                            props.screenNumber,
                            props.slots,
                            props.shopsNumber
                        )
                    }
                >
                    Télécharger récapitulatif
                </button>
            </div>
        </div>
    );
};
